import { gachaConfig } from '../config/gacha';

function rollStar(randomValue = Math.random() * 100) {
    const matched = gachaConfig.rarityRates.find((rate) => randomValue < rate.threshold);
    return matched?.star ?? 5;
}

function randomPick(items) {
    if (!items.length) {
        return null;
    }

    const index = Math.floor(Math.random() * items.length);
    return items[index];
}

function getFallbackItem(items, targetItem) {
    return targetItem ?? items[0] ?? null;
}

export function createInitialCategorySession() {
    return {
        selectItem: null,
        count: 0,
        wishHistory: [],
        lastResult: null,
        lastStar: 3,
        wasTargetHit: false,
        totalDraws: 0,
        fiveStarStreak: 0,
        mood: 'calm',
    };
}

export function resolveWish({ items, session, targetItem }) {
    const maxDraws = gachaConfig.maxDraws;
    const progress = session?.count ?? 0;
    const hasTarget = Boolean(targetItem);

    let nextStar = rollStar();
    if (!hasTarget && progress >= maxDraws - 1) {
        nextStar = 5;
    }

    const pool = items.filter((item) => item.star === nextStar);
    let result = randomPick(pool);
    let wasTargetHit = false;

    if (hasTarget) {
        const shouldGuaranteeTarget = progress >= maxDraws - 1;
        if (shouldGuaranteeTarget) {
            result = targetItem;
            nextStar = targetItem.star;
            wasTargetHit = true;
        } else if (result && result.id === targetItem.id) {
            wasTargetHit = true;
        }
    }

    if (!result) {
        result = getFallbackItem(items, targetItem);
        if (result) {
            nextStar = result.star;
            wasTargetHit = Boolean(targetItem && result.id === targetItem.id);
        }
    }

    const nextCount = hasTarget
        ? (wasTargetHit ? 0 : Math.min(progress + 1, maxDraws - 1))
        : (nextStar === 5 ? 0 : Math.min(progress + 1, maxDraws - 1));

    const nextHistory = [...(session?.wishHistory ?? []), result].filter(Boolean);

    const totalDraws = (session?.totalDraws ?? 0) + 1;
    const fiveStarStreak = nextStar === 5 ? 0 : (session?.fiveStarStreak ?? 0) + 1;
    const mood = wasTargetHit
        ? 'target-hit'
        : nextStar === 5
            ? 'jackpot'
            : fiveStarStreak >= maxDraws - 1
                ? 'tense'
                : 'calm';

    return {
        result,
        star: nextStar,
        nextSession: {
            ...session,
            selectItem: targetItem ?? null,
            count: nextCount,
            wishHistory: nextHistory,
            lastResult: result,
            lastStar: nextStar,
            wasTargetHit,
            totalDraws,
            fiveStarStreak,
            mood,
        },
        wasTargetHit,
    };
}
